import { cookieBus } from "@/common/buses";
import { useCallback, useEffect } from "react";

export const useTrackCookieConsent = () => {
  const consentUpdate = useCallback(() => {
    cookieBus.emit("consent_update");
  }, []);

  useEffect(() => {
    document.addEventListener("cookieyes_consent_update", consentUpdate);

    return () => {
      document.removeEventListener("cookieyes_consent_update", consentUpdate);
    };
  }, [consentUpdate]);
};
